export default __webpack_public_path__ + "static/media/network.7deb539d.png";